export class SysConfigModel {
    public num: number;
    public nam: string;
    public set: number;
    public value: string;
    public notes: number;
    public editable: number;

    [x: string]: any;
}
